import React, { useEffect, useCallback } from "react";
import { useHistory } from "react-router-dom";
import { useTracker } from "@dpdgroupuk/react-event-tracker";

import SectionList from "../../../components/LeftMenu/components/SectionComponents/SectionList";
import useLocationQueryParams from "../../../hooks/useLocationQueryParams";
import { stringifyQuery } from "../../../utils/query";
import { ROUTES_PAGE, SECTION_FULL_PAGE } from "../../../constants/routes";
import { SECTIONS } from "../../../constants/analytics";

const SectionListContainer = () => {
  const query = useLocationQueryParams();
  const history = useHistory();
  const tracker = useTracker();

  useEffect(() => {
    tracker.logEvent(SECTIONS.LOAD);
  }, [tracker]);

  const onTabChange = useCallback(
    (e, value) => {
      history.push({
        pathname: value,
        search: history.location.search,
      });

      tracker.logEvent(
        SECTIONS[
          value === SECTION_FULL_PAGE ? "SELECT_STATS_VIEW" : "SELECT_LIST_VIEW"
        ]
      );
    },
    [history, tracker]
  );

  const onSectionClick = useCallback(
    (sectionCode) => {
      tracker.logEvent();

      const { sectionId, ...newQuery } = query;

      if (parseInt(sectionId) !== parseInt(sectionCode)) {
        newQuery.sectionId = sectionCode;
      }

      history.push({
        search: stringifyQuery(newQuery),
      });

      tracker.logEvent(SECTIONS.CLICK_SECTION);
    },
    [history, query, tracker]
  );

  const onSectionDoubleClick = useCallback(
    (sectionId) => {
      history.push({
        pathname: ROUTES_PAGE,
        search: stringifyQuery({
          ...query,
          sectionId,
        }),
      });

      tracker.logEvent(SECTIONS.DOUBLE_CLICK_SECTION);
    },
    [history, query, tracker]
  );

  return (
    <SectionList
      onTabChange={onTabChange}
      onSectionClick={onSectionClick}
      onSectionDoubleClick={onSectionDoubleClick}
    />
  );
};

export default SectionListContainer;
